import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { SealContainer } from "./SealContainer";

export class InfoScene extends Phaser.Scene {

    public static currentInstance: InfoScene; 
   
    constructor() {

        super("InfoScene");
        
        InfoScene.currentInstance = this;
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        const background = this.add.graphics();
        background.fillStyle(0xFF0000);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        
        const title = new Phaser.GameObjects.Text(this, GameConstants.GAME_WIDTH / 2, 140 * GameVars.scaleY, "ПОЛУЧИТЬ ВРАЩЕНИЕ", { fontFamily: "FuturaPTBold", fontSize: "62px", color: "#FFC24B"});
        title.setOrigin(.5)
        title.scaleY = GameVars.scaleY;
        this.add.existing(title);

        const scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT  * .45);
       
        if (GameVars.aspectRatio < 1.5) {
            
            scaledItemsContainer.scaleX = .75;
            scaledItemsContainer.scaleY = .75 * GameVars.scaleY;

        } else if (GameVars.aspectRatio < 1.65) {

            scaledItemsContainer.scaleX = .85;
            scaledItemsContainer.scaleY = .85 * GameVars.scaleY;
            
        } else {
            scaledItemsContainer.scaleY = GameVars.scaleY;
        }

        const seal1 = new SealContainer(this, 1);
        seal1.y = -350;
        scaledItemsContainer.add(seal1);

        const seal2 = new SealContainer(this, 2);
        seal2.y = 380;
        scaledItemsContainer.add(seal2);

        const closeButton = new Phaser.GameObjects.Image(this, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT - 180 * GameVars.scaleY, "texture_atlas_1", "btn_close");
        closeButton.setInteractive();
        closeButton.scaleY = GameVars.scaleY;
        closeButton.on("pointerover", () => {
            closeButton.setScale(1.05, 1.05 * GameVars.scaleY);
        }, this);

        closeButton.on("pointerout", () => {
            closeButton.setScale(1, GameVars.scaleY);
        }, this);

        closeButton.on("pointerdown", () => {
            closeButton.setScale(1.05, 1.05 * GameVars.scaleY);
        }, this);

        closeButton.on("pointerup", () => {
            closeButton.setScale(1);
            GameManager.enterRouletteScene();
            this.sound.playAudioSprite("audio-sprite", "click_btn");
        }, this);

        this.add.existing(closeButton);
    
        this.cameras.main.fadeIn(200, 194, 0, 0)
    }
}
